


















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { IProductDocumentsItem } from '~/assets/interfaces/products'
import MixinGeneral from '~/assets/mixins/general'
import { extensions } from '~/assets/images/ext/extensions'
import { filterByteToSize } from '~/assets/filters/files'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
  },
  filters: {
    filterByteToSize,
  },
})
export default class ComponentProductDocuments extends mixins(MixinGeneral) {
  @Prop({ type: Array, default: [] }) private items!: IProductDocumentsItem[]

  private imagePath(ext: string) {
    return extensions[ext] ? extensions[ext] : extensions.pdf
  }
}
